var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'users-view', params: { userId: _vm.user.id } }},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.user.fullname || _vm.user.username)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }